import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";

import { RoutingTabs } from "../../components/RoutingTabs";
import { APP_ROUTES } from "../../helpers/routeHelpers";
import Detail_Profile from "./Detail_Profile";
import CategoriesAndAvailibility from "./Detail_CatAvail";
import DetailJob from "./Detail_Job";
import DetailPromotions from "./Detail_Promotions";
import DetailRatingAndReviews from "./Detail_RatingAndReviews";
import { SwitchInput } from "../../components/Input";
import { CustomButton } from "../../components/CustomButton";
import suspendModalImg from "../../assets/images/app/common/modal-suspend-img.svg";
import deleteModalImg from "../../assets/images/app/common/modal-delete-img.svg";
import { ConfirmationModal } from "../../components/CustomModal";
import { useRequestProcessor } from "../../hooks/useRequestProcessors";
import { getKey, MODULE_KEYS } from "../../api/api.keys";
import { DeleteUserById, GetProviderById, UpdateUserById } from "../../api/api.service";
import { showToast, SUCCESS } from "../../utils/toastUtils";
import { Col, Label, Row } from "reactstrap";
import { HeaderBackButton } from "../../components/HeaderBackButton";
import { hasData } from "../../utils/commonUtils";
import { LoaderFallbackUI } from "../../components/LoaderFallbackUI";
import { JobsStatus } from "../../constants";

const ACTIVE = "ACTIVE";
const INACTIVE = "INACTIVE";
const PROVIDER = "PROVIDER";

const MODAL_CONTENT_CONFIG = {
    [ACTIVE]: {
        modalTitle: "Are you sure you want to activate this provider?",
        yesButtonText: "Yes",
        noButtonText: "Cancel",
        imageSrc: suspendModalImg
    },
    [INACTIVE]: {
        modalTitle: "Are you sure you want to deactivate this provider?",
        yesButtonText: "Yes",
        noButtonText: "Cancel",
        imageSrc: suspendModalImg
    },
    DELETE: {
        modalTitle: "Are you sure you want to delete this provider?",
        yesButtonText: "Yes",
        noButtonText: "Cancel",
        imageSrc: deleteModalImg
    }
};

const Details = () => {
    const history = useHistory();
    const { providerId } = useParams();
    const [providerStatus, setProviderStatus] = useState(null);
    const [modalConfig, setModalConfig] = useState(null);
    const { useFetch, useMutate } = useRequestProcessor();

    const { data, isLoading, isError, isFetching } = useFetch(
        getKey([MODULE_KEYS.PROVIDER_PROFILE_DETAIL], { providerId }),
        async ({ signal }) => await GetProviderById({ Id: providerId, params: {}, signal }),
        {
            onSuccess: (res) => {
                setProviderStatus(res?.provider?.status);
            }
        }
    );

    const { mutate: updateProviderStatus, isLoading: isStatusUpdate } = useMutate(
        "",
        getKey(),
        (data) => UpdateUserById({ Id: providerId, bodyData: data })
    );

    const { mutate: deleteProviderMutate, isLoading: isDeleted } = useMutate("", getKey(), (data) =>
        DeleteUserById({ Id: providerId })
    );

    const handleToggleStatus = () => {
        const nextStatus = providerStatus === ACTIVE ? INACTIVE : ACTIVE;
        setModalConfig(MODAL_CONTENT_CONFIG[nextStatus]);
    };

    const handleDelete = () => {
        setModalConfig(MODAL_CONTENT_CONFIG.DELETE);
    };

    const handleActionConfirmation = () => {
        if (modalConfig === MODAL_CONTENT_CONFIG.DELETE) {
            deleteProviderMutate(
                {},
                {
                    onSuccess: () => {
                        showToast(SUCCESS, "Provider has been deleted successfully");
                        history.push(APP_ROUTES.PROVIDER_MANAGEMENT);
                    },
                    onError: () => {}
                }
            );
        } else {
            const nextStatus = providerStatus === ACTIVE ? INACTIVE : ACTIVE;
            updateProviderStatus(
                { type: PROVIDER, status: nextStatus },
                {
                    onSuccess: () => {
                        showToast(SUCCESS, "Status has been updated successfully");
                        setProviderStatus(nextStatus);
                    },
                    onError: () => {}
                }
            );
        }

        setModalConfig(null);
    };

    const handleActionCancellation = () => {
        setModalConfig(null);
    };

    const CONFIG = {
        param: { providerId },
        tabsConfig: [
            {
                title: "Profile",
                id: "1",
                defaultActive: true,
                path: APP_ROUTES.PROVIDER_DETAILS,
                component: <Detail_Profile data={data} />
            },
            {
                title: "Services and Availability",
                id: "2",
                defaultActive: false,
                path: APP_ROUTES.PROVIDER_DETAILS_CATANDAVAIL,
                component: (
                    <CategoriesAndAvailibility
                        providerCategories={data?.providerCategories}
                        providerAvailibility={data?.providerAvailability}
                        isLoading={isLoading}
                        isFetching={isFetching}
                    />
                )
            },
            {
                title: "Jobs",
                id: "3",
                defaultActive: false,
                path: APP_ROUTES.PROVIDER_DETAILS_JOBS,
                component: <DetailJob />
            },
            {
                title: "Promotions",
                id: "4",
                defaultActive: false,
                path: APP_ROUTES.PROVIDER_DETAILS_PROMOTIONS,
                component: <DetailPromotions />
            },
            {
                title: "Rating and Reviews",
                id: "5",
                defaultActive: false,
                path: APP_ROUTES.PROVIDER_DETAILS_RATANDREVIEWS,
                component: <DetailRatingAndReviews ratingData={data?.rating} />
            }
        ]
    };

    if (isFetching || isLoading || !hasData(data)) {
        return (
            <div style={{ height: "70vh" }}>
                <LoaderFallbackUI isLoader={isFetching} className={"h-100"} />
            </div>
        );
    }

    return (
        <>
            <div className="page-content">
                <Row className="d-flex align-items-center">
                    <Col sm="12" md="2" lg="2"></Col>
                    <Col sm="12" md="3" lg="3"></Col>
                    <Col sm="12" md="7" lg="7">
                        <div className="user-management-details-option-container">
                            <div className="  d-flex align-items-center me-3">
                                <Label className="mb-0 me-3">Account Status:</Label>
                                <SwitchInput
                                    size="lg"
                                    isChecked={providerStatus === ACTIVE}
                                    onClick={handleToggleStatus}
                                />
                            </div>
                            <div className="user-management-delete-container ">
                                <CustomButton
                                    disabled={
                                        !(
                                            providerStatus == JobsStatus.ACTIVE ||
                                            providerStatus == JobsStatus.IN_PROGRESS
                                        )
                                    }
                                    title={"Delete"}
                                    className={`custom-btn-action-red`}
                                    onClick={handleDelete}
                                    type="button"
                                />
                            </div>
                        </div>
                    </Col>
                    <RoutingTabs
                        config={CONFIG}
                        isPills
                        isTabs={false}
                        parentRoute={APP_ROUTES.PROVIDER_MANAGEMENT_DETAILS}
                    />
                </Row>
            </div>

            <ConfirmationModal
                size="md"
                hasCustomConfig
                isOpen={modalConfig !== null}
                customImageSrc={modalConfig?.imageSrc}
                customTitle={modalConfig?.modalTitle}
                customYesBtnText={modalConfig?.yesButtonText}
                customNoBtnText={modalConfig?.noButtonText}
                onYes={handleActionConfirmation}
                onNo={handleActionCancellation}
                yesLoading={isStatusUpdate || isDeleted}
            />
        </>
    );
};

export default Details;
